import React, { useState } from 'react';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { AuthenticatedRoutes } from '@client/components/navigation/AuthenticatedRoutes';
import { UnauthenticatedRoutes } from '@client/components/navigation/UnauthenticatedRoutes';
import { MobileNavigation } from '@client/components/navigation/MobileNavigation';
import { Logo } from '@client/components/logo/Logo';
import HamburgerIcon from '@client/components/hamburgerIcon/HamburgerIcon';
import styles from './navigation.scss';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const auth = useAuth0();
  const isAuthenticated = auth?.isAuthenticated;

  return (
    <div className={styles.navigation}>
      <Logo />
      <ul className={styles.list}>
        {isAuthenticated && <AuthenticatedRoutes />}
        {!isAuthenticated && <UnauthenticatedRoutes />}
      </ul>
      <HamburgerIcon
        className={styles.mobileNavButton}
        onClick={() => setIsOpen(!isOpen)}
        isCrossed={isOpen}
        label={'Navigation'}
      />
      <MobileNavigation
        isOpen={isOpen}
        handleClick={() => setIsOpen(false)}
        isAuthenticated={isAuthenticated}
      />
    </div>
  );
};
